<template>
  <div class="general-fields__wrapper">
    <h5>Batch File</h5>
    <div>
      <validation-provider
        v-slot="{errors, touched, validated, valid}"
        rules="required"
        name="Name"
      >
        <b-form-group label="Name">
          <b-form-input
            id="batch-file-name"
            v-model="formFromStore.batchFileName"
            placeholder="Name"
            :state="(!touched && !validated) ? null : valid ? null : false"
          />
        </b-form-group>
        <span
          v-if="errors"
          class="error__message"
        >
          {{ errors[0] }}
        </span>
      </validation-provider>
      <entities-multiselect
        :is-entity-guid-valid="isEntityGuidValid"
        :batch-file="batchFile"
        :is-edit-mode="isEditMode"
        :is-batch-file-modal="true"
      />
      <validation-provider
        v-slot="{errors, touched, validated, valid}"
        rules="required"
        name="File Type"
      >
        <b-form-group label="File Type">
          <b-form-select
            id="batch-file-type"
            v-model="formFromStore.batchFileType"
            :state="(!touched && !validated) ? null : valid ? null : false"
            :options="fileTypeOptions"
            :disabled="isEditMode"
            @change="generateFormForType"
          />
        </b-form-group>
        <span
          v-if="errors"
          class="error__message"
        >
          {{ errors[0] }}
        </span>
      </validation-provider>

      <validation-provider
        v-slot="{errors, touched, validated, valid}"
        rules="required"
        name="Dependency Group"
      >
        <b-form-group label="Dependency Group">
          <b-form-input
            id="dependency-group"
            v-model="formFromStore.dependencyGroup"
            placeholder="Please choose Dependency Group"
            :state="(!touched && !validated) ? null : valid ? null : false"
            type="number"
          />
        </b-form-group>
        <span
          v-if="errors"
          class="error__message"
        >
          {{ errors[0] }}
        </span>
      </validation-provider>
    </div>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import {fileManipulationMixin} from '@/modules/FileManipulationController/file-manipulation.mixin';
import EntitiesMultiselect
  from '@/modules/FileManipulationController/BatchList/components/AddEditBatchModalParts/EntitiesMultiselect.vue';

const {
  mapState: sidebarMapState,
} = createNamespacedHelpers('sidebar');

const {
  mapState: fileManipulationMapState,
  mapActions: fileManipulationMapActions,
} = createNamespacedHelpers('fileManipulationController');

export default {
  name: 'GeneralFields',
  components: {EntitiesMultiselect},
  mixins: [fileManipulationMixin],
  props: ['batchFile', 'isEntityGuidValid'],
  data() {
    return {
      entity: '',
      fileTypeOptions: [
        {id: 0, value: null, text: 'Select option please'},
        {id: 1, text: 'Excel', value: 'excel'},
        {id: 2, text: 'Bulk Flat File', value: 'bulkFlatFile'},
        {id: 3, text: 'Flat File', value: 'flatFile'},
      ],
    };
  },
  computed: {
    ...fileManipulationMapState({
      formFromStore: state => state.formFromStore,
    }),
    ...sidebarMapState({
      tablesList: state => state.tablesList,
    }),
    isEditMode() {
      return !!Object.values(this.batchFile).length;
    },
  },
  methods: {
    ...fileManipulationMapActions(['updateFormInStore', 'changeFileType']),
    generateFormForType(type) {
      this.changeFileType(type);
      this.collectAddEditBatchFileModalFormInEditMode();
    },
  },
};
</script>


<style scoped lang="scss">
.useBulkUpload__wrapper {
  display: flex;
  align-items: center;

  label {
    margin-bottom: 0;
  }
}
.general-fields__wrapper {
  & .form-group {
    position: relative;

  }
  & .error__message {
    position: absolute;
    color: red;
    transform: translateY(-100%);
    font-size: 10px;
  }
}
</style>